import { useState } from 'react'

const EMPTY_FORM = { name: '', email: '', contact: '', consent: false }

const ConsentModal = ({ show, onConfirm, onClose }) => {
    const [form, setForm] = useState(EMPTY_FORM)
    const [errors, setErrors] = useState({})

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target
        setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }))
        setErrors(prev => ({ ...prev, [name]: undefined }))
    }

    const validate = () => {
        const e = {}
        if (!form.name.trim())    e.name    = 'Le nom est requis.'
        if (!form.email.trim())   e.email   = "L'email est requis."
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Email invalide.'
        if (!form.contact.trim()) e.contact = 'Le contact est requis.'
        if (!form.consent)        e.consent = 'Vous devez donner votre consentement.'
        return e
    }

    const handleConfirm = () => {
        const e = validate()
        if (Object.keys(e).length > 0) { setErrors(e); return }
        onConfirm({ name: form.name.trim(), email: form.email.trim(), contact: form.contact.trim() })
        setForm(EMPTY_FORM)
        setErrors({})
    }

    const handleClose = () => {
        setForm(EMPTY_FORM)
        setErrors({})
        onClose()
    }

    if (!show) return null

    return (
        <>
            <div
                className="modal fade show modal-dark"
                style={{ display: 'block' }}
                tabIndex="-1"
                aria-modal="true"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Informations & consentement</h5>
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close" />
                        </div>

                        <div className="modal-body">
                            <p className="small mb-3" style={{ color: 'rgba(255,255,255,0.5)' }}>
                                Ces informations sont nécessaires pour associer les images collectées
                                à votre identité dans le dataset.
                            </p>

                            <div className="mb-3">
                                <label htmlFor="consent-name" className="form-label" style={{ color: 'rgba(255,255,255,0.8)' }}>Nom complet <span className="text-danger">*</span></label>
                                <input
                                    id="consent-name"
                                    type="text"
                                    name="name"
                                    className={`form-control form-control-dark ${errors.name ? 'is-invalid' : ''}`}
                                    value={form.name}
                                    onChange={handleChange}
                                    placeholder="Angelo YAMEOGO"
                                    style={{ color: 'rgba(255,255,255,0.8)' }}
                                />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </div>

                            <div className="mb-3">
                                <label htmlFor="consent-email" className="form-label" style={{ color: 'rgba(255,255,255,0.8)' }}>Email <span className="text-danger">*</span></label>
                                <input
                                    id="consent-email"
                                    type="email"
                                    name="email"
                                    className={`form-control form-control-dark ${errors.email ? 'is-invalid' : ''}`}
                                    value={form.email}
                                    onChange={handleChange}
                                    placeholder="awesomedevstudio@gmail.com"
                                    style={{ color: 'rgba(255,255,255,0.8)' }}
                                />
                                {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                            </div>

                            <div className="mb-3">
                                <label htmlFor="consent-contact" className="form-label" style={{ color: 'rgba(255,255,255,0.8)' }}>Contact (téléphone) <span className="text-danger">*</span></label>
                                <input
                                    id="consent-contact"
                                    type="text"
                                    name="contact"
                                    className={`form-control form-control-dark ${errors.contact ? 'is-invalid' : ''}`}
                                    value={form.contact}
                                    onChange={handleChange}
                                    placeholder="+22665689156"
                                    style={{ color: 'rgba(255,255,255,0.8)' }}
                                />
                                {errors.contact && <div className="invalid-feedback">{errors.contact}</div>}
                            </div>

                            <div className="mb-1">
                                <div className={`form-check ${errors.consent ? 'is-invalid' : ''}`}>
                                    <input
                                        id="consent-checkbox"
                                        type="checkbox"
                                        name="consent"
                                        className={`form-check-input ${errors.consent ? 'is-invalid' : ''}`}
                                        checked={form.consent}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="consent-checkbox" className="form-check-label small" style={{ color: 'rgba(255,255,255,0.7)' }}>
                                        Je consens à ce que mes images faciales soient utilisées dans
                                        le cadre de ce projet de recherche sur la reconnaissance faciale.
                                    </label>
                                </div>
                                {errors.consent && <div className="invalid-feedback d-block">{errors.consent}</div>}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={handleConfirm}>
                                Confirmer et envoyer
                            </button>
                            <button type="button" className="btn btn-outline-light" onClick={handleClose}>
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" style={{ background: 'rgba(5,15,30,0.8)' }} onClick={handleClose} />
        </>
    )
}

export default ConsentModal
